import React from 'react';

import { OrderTypeEnum } from '@portal/schema';

import { BaseStepType } from '../../data';
import { MoveReview } from './move_review';
import { OnboardingReview } from './onboarding_review';

export const Review: React.FC<BaseStepType> = (props) => {
  const { orderType } = props;

  return orderType === OrderTypeEnum.Move ? <MoveReview {...props} /> : <OnboardingReview {...props} />;
};
